import { CountryCode } from '../../i18n/countryCodes'
import { IObjectType } from './index'

export default function fetchCountry(api: GlobalFetch) {
  return function(lang: CountryCode) {
    return api
      .fetch(`/api/v2/misc/objecttype/lang/${lang}`)
      .then((res): Promise<IData> => res.json())
      .then((res): IObjectType[] =>
        res.items.map(
          (item): IObjectType => ({
            id: item.id,
            name: item.name,
          }),
        ),
      )
  }
}

interface IData {
  items: IObjectTypeData[]
  messages: string[]
}

interface IObjectTypeData {
  id: number
  name: string
}
